import { getColor, getSize, getWeight } from "views/resources/theme";
import styled from "styled-components";

export const Wrapper = styled.div`
	h2 {
		color: ${getColor("secondary")};
		font-weight: ${getWeight("ultrabold")};
		font-family: Roboto;
	}

	h2,
	h3 {
		text-align: left;
		color: ${getColor("primary")};
	}

	p {
		color: ${getColor("fg")};
		text-align: center;
		font-weight: ${getWeight("medium")};
		font-size: ${getSize("m")};
	}

	.close {
		color: ${getColor("disabled")};
		font-weight: ${getWeight("semibold")};
		text-decoration: underline;
	}

	.comment {
		color: ${getColor("disabled")};
		font-size: ${getSize("sm")};
	}
`;

export const Title = styled.h3`
	margin: ${getSize("s")} 0;
	font-size: ${getSize("m")};
	line-height: ${getSize("mm")};
	color: ${getColor("fg")};
`;

export const Header = styled.p`
	font-family: Roboto;
	font-size: ${getSize("sm")};
	padding: 0;
	margin: 0;
`;

export const FlexCol = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
`;

export const FlexRow = styled.div`
	display: flex;
	align-items: center;
`;

export const Left = styled.div`
	padding: ${getSize("l")};
	box-sizing: border-box;
`;

export const A = styled.div`
	color: ${getColor("secondary")};
	font-size: ${getSize("m")};
	font-family: Roboto;
	margin: ${getSize("s")};
	cursor: pointer;

	&:hover {
		color: ${getColor("secondary_light")};
	}
`;

// popup whatsapp

export const WhatsappSection = styled.div`
	font-weight: bold;

	p {
		margin-top: 5px;
		font-weight: normal;
		font-size: 12px;
		text-align: left;
		a {
			font-weight: bold;
			color: ${getColor("primary")};
		}
	}

	.whatsappBox {
		background: #d0faef;
		padding: 10px;
		border-radius: 10px;
	}

	.ant-checkbox {
		float: left;
		margin: 10px;
	}

	.ant-checkbox + span {
		padding-left: 0px;
		color: #2a9854;
	}

	.ant-checkbox-wrapper {
		text-align: left;
	}

	.ant-checkbox-inner {
		width: 26px;
		height: 26px;
	}

	.ant-checkbox-inner::after {
		width: 7px;
		height: 15px;
		left: 26%;
		top: 42%;
	}

	.ant-checkbox-checked .ant-checkbox-inner {
		background-color: #2a9854;
	}

	input[type="checkbox"] {
		transform: scale(1.6);
	}
`;

export const PhoneSection = styled.div`
	h4 {
		text-align: left;
		color: ${getColor("primary")};
	}
	h3 {
		color: #a2a2a2;
		font-weight: 600;
		font-size: 16px;
		margin-bottom: 1rem;
		display: block;
	}
	label {
		display: none;
	}

	input[type="text"] {
		padding: 5px;
		::placeholder {
			color: #eee;
		}
	}

	a.ant-dropdown-trigger {
		padding: 5px 10px;
		border: 1px solid #dedede;
	}

	.input-feeedback {
	}
`;

export const CloseSection = styled.div`
	text-align: right;
	margin-bottom: 10px;
	span {
		&:hover {
			cursor: pointer;
		}
	}
`;
